<template>
  <div id="about-us-content" class="support-content" v-html="supportContent"></div>
</template>


<script>
import supportMixins from "../../mixins/supportMixins";

export default {
  metaInfo: {
    title: "About Us | 1byone health",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "1byone is a global online store, specialized in creating healthy life with our product like smart body fat scale, blood pressure monitor, oximeter, TENS and etc "
      },
      {
        vmid: "keywords",
        name: "keywords",
        content:
          "1byone,1byone.com,1byone company,1byone products, 1byone health, 1byonehealth.com"
      }
    ]
  },
  mixins: [supportMixins("AboutUs")]
};
</script>